var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStarHalfOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M12 6.625v9.062l3.68 2.237-.964-4.183 3.24-2.788-4.262-.378zm0 11.792-4.847 2.905a1.07 1.07 0 0 1-.672.174 1.13 1.13 0 0 1-.613-.232 1.4 1.4 0 0 1-.409-.508 1 1 0 0 1-.058-.683l1.285-5.49-4.293-3.689a1.11 1.11 0 0 1-.321-1.249q.117-.32.35-.522.234-.204.643-.262l5.665-.494 2.19-5.17q.146-.349.452-.523T12 2.5q.32 0 .628.174.306.174.452.523l2.19 5.17 5.665.494q.41.058.643.262.233.203.35.522.117.32.044.654t-.365.595l-4.292 3.69 1.284 5.49q.089.376-.058.682a1.4 1.4 0 0 1-.409.508q-.263.204-.613.232a1.07 1.07 0 0 1-.672-.174z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarHalfOutline);
export default __webpack_public_path__ + "static/media/star_half_outline.bdefbd767000f5fa8945efd9f84d6862.svg";
export { ForwardRef as ReactComponent };